import React, { useEffect, useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import Modal from '../../../ui/Modal';

const blockEl = 'invoices__calendar-modal';

const CalendarModal = ({
  isOpen,
  onClose,
  onSave,
  variant,
  invoiceDetailID,
  invoiceID,
  paymentMethods,
  presetDate,
  paymentMethodID = 0,
  currentStatus = false,
  pickup,
}) => {
  const [buttonDisabled, setButtonDisabled] = useState(variant !== 'Shipped' && !currentStatus);
  const [dateValue, setDateValue] = useState(new Date());
  const [methodValue, setMethodValue] = useState('');

  let variantText = variant;
  if (variant === 'Shipped' && pickup) variantText = 'Picked Up';

  useEffect(() => {
    setButtonDisabled(variant === 'Paid' && methodValue === '' && !currentStatus);
  }, []);

  useEffect(() => {
    setDateValue(presetDate ? new Date(presetDate) : new Date());
  }, [presetDate]);

  useEffect(() => {
    setButtonDisabled(variant === 'Paid' && methodValue === '' && !currentStatus);
  }, [methodValue, variant]);

  const closeAndReset = () => {
    setMethodValue('');
    setDateValue(new Date());
    onClose();
  };

  const handleDateValue = (date) => {
    setDateValue(date);
  };

  const handleMethodValue = (e) => {
    setMethodValue(e.target.value);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const mPart = (dateValue.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    const dPart = dateValue.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    const yPart = dateValue.getFullYear().toString().substring(2);
    const formattedDate = `${mPart}/${dPart}/${yPart}`;

    const payloadData = {
      invoiceID,
      // invoiceDetailID === -1 is used for group details and other invoiced-based
      invoiceDetailID: (invoiceDetailID > 0) ? invoiceDetailID : '',
    };

    if (variant === 'Paid') {
      payloadData.paid = !currentStatus;
      payloadData.paidDate = currentStatus ? null : formattedDate;
      payloadData.paymentMethodID = currentStatus ? 0 : Number(methodValue);
    } else if (variant === 'Shipped') {
      payloadData.shipped = !currentStatus;
      payloadData.shippedDate = currentStatus ? null : formattedDate;
    }

    onSave(payloadData, variantText);
    setMethodValue('');
    setDateValue(new Date());
  };

  return (
    <Modal isOpen={isOpen} className={blockEl} toggle={closeAndReset}>
      <Modal.Header toggle={closeAndReset}>
        {currentStatus ? (
          <span className="no-caps">
            Do you want to mark this {invoiceDetailID > 0 ? 'Item' : 'Invoice'} as not {variantText.toLowerCase()}?
          </span>
        ) : (
          <span>
            Mark {invoiceDetailID === -1 ? 'Invoice' : 'Item'} as {variantText}
          </span>
        )}
      </Modal.Header>
      <form onSubmit={handleOnSubmit} noValidate>
        <Modal.Body>
          {!currentStatus && variant === 'Paid' && (
            <div>
              <FormGroup>
                <Label for="subject">Select Payment Method</Label>
                <Input
                  type="select"
                  name="method"
                  defaultValue={paymentMethodID}
                  onChange={handleMethodValue}
                  className="w-75"
                >
                  <option value="">Please select method</option>
                  {paymentMethods.map((method) => (
                    <option value={method.id} key={method.id}>{method.name}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
          )}
          {!currentStatus && (
            <div className="full-width-datepicker mt-4">
              <DatePicker
                id="eventDate"
                className="w-100"
                selected={dateValue}
                onChange={date => handleDateValue(date)}
                inline
                maxDate={new Date()}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" color="link" onClick={closeAndReset}>
            {currentStatus ? 'No, cancel' : 'Cancel'}
          </Button>
          {currentStatus ? (
            <Button type="submit" color="primary">
              Yes, Mark as Not {variantText}
            </Button>
          ) : (
            <Button type="submit" color="primary" disabled={buttonDisabled}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  );
};

CalendarModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  variant: PropTypes.string.isRequired,
  invoiceID: PropTypes.number.isRequired,
  invoiceDetailID: PropTypes.number.isRequired,
};

CalendarModal.defaultProps = {
  isOpen: false,
  onClose: Function.prototype,
  onSave: Function.prototype,
};

export default CalendarModal;
